module.exports = __webpack_public_path__ + "static/media/eiffelWrong.9de436a2.png";